<template>
  <div>
    <PageTitle
      title="Services"
      :btnCreate="true"
      :createRoute="'/service/add'"
      :permission="'Service Create'"
    />
    <v-container fluid class="lighten-12 content">
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <TableFilters
            :filters="['category', 'status', 'search']"
            v-model="filter"
            :columns="columns"
            :msgs="'Name/Code'"
          ></TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="services"
                item-key="id"
                hide-default-footer
                class="row-pointer service-txt"
              >
                <template v-slot:no-data>
                  <noData
                    class="mt-10 container justify-center item-center"
                    name="service"
                  />
                </template>

                <template v-slot:item.code="{ item }">
                  <div class="d-flex justify-center align-center">
                    <CopyTableCell :text="item.code" />
                  </div>
                </template>

                <!-- No -->
                <template v-slot:item.no>
                  <v-icon>mdi-vuetify</v-icon>
                </template>
                <!-- Image -->
                <template v-slot:item.image="{ item }">
                  <img
                    v-if="item.image"
                    :src="item.image"
                    height="32"
                    width="32"
                    class="image"
                  />
                  <v-avatar v-else size="26px" item color="primary">
                    <span class="white--text subtitle-2 text-uppercase">
                      {{ item.name.substring(0, 2) }}</span
                    >
                  </v-avatar>
                </template>
                <!-- <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="px-5">
                      <template>
                        <AuditLogs :Type="'services'" :Typeid="item.id" />
                      </template>
                    </td>
                  </template> -->
                <!-- Category -->
                <template v-slot:item.category="{ item }">{{
                  item.category.name ? item.category.name : '-'
                }}</template>

                <!-- Brand -->
                <template v-slot:item.brand="{ item }">{{
                  item.brand.name ? item.brand.name : '-'
                }}</template>

                <!-- Status -->
                <template v-slot:item.status="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2 cursor-pointer"
                    label
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                  >
                </template>

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="service"
                    :item="item"
                    editPermission="Service Edit"
                    softDeletePermission="Service Soft Delete"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    @getPageNumber="setPagenumber"
                    :filterAction="true"
                    url="services"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>

      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import pagination from '../../shared/components/pagination';
import TableFilters from '@/components/base/TableFilters';
import noData from '../../../components/shared/noItem';

export default {
  data: () => ({
    show: false,
    paginationOptions: {},
    // expanded: [],
    // singleExpand: false,

    columns: [
      {
        text: 'Image',
        value: 'image',
        show: true,
        disabled: true,
        width: '14%',
        align: 'center',
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: true,
        width: '14%',
        align: 'center',
      },
      {
        text: 'Code',
        value: 'code',
        show: true,
        disabled: false,
        width: '14%',
        align: 'center',
      },
      {
        text: 'Category',
        value: 'category',
        show: true,
        disabled: false,
        width: '14%',
        align: 'center',
      },
      {
        text: 'Amount',
        value: 'amount',
        show: true,
        disabled: false,
        width: '14%',
        align: 'center',
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        width: '14%',
        align: 'center',
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        width: '14%',
        align: 'center',
      },
    ],
    services: [],
    // Filters
    filter: {
      category: '',
      search: '',
      status: '',
    },
  }),
  components: {
    PageTitle,
    pagination,
    TableFilters,
    noData,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },

    setResponseData(serviceData) {
      this.services = serviceData;
      this.services.map((u) => {
        if (u.image) {
          u.image = u.image + '?t=' + new Date().getTime();
        }
      });
    },
    clearFilter() {
      this.filter = {};
    },
    getStatusColor(is_active) {
      return is_active ? 'green' : 'gray';
    },
  },
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.service-txt {
  /* font-weight: bold; */
  font-family: 'Source Sans Pro', sans-serif;
}
.min-button::before {
  display: none;
}
</style>
